import { ATP_API_URL } from "../config/apiConfig";
import { apiClient } from "../services/apiClient";

/**
 * Fetches a document as a blob for inline preview or new-tab viewing.
 * GET api/Onboarding/view-document?entityPrimaryId={id}&filePath={path}
 *
 * @param {number} entityPrimaryId
 * @param {string} filePath  - raw Windows path from the API response
 */
export const viewDocumentAction = async (entityPrimaryId, filePath) => {
  try {
    // console.log("[ViewDocument] Requesting:", { entityPrimaryId, filePath });

    const response = await apiClient.get(ATP_API_URL.VIEW_DOCUMENT, {
      params: { entityPrimaryId, filePath },
      responseType: "blob",
    });

    // console.log("[ViewDocument] Response status:", response?.status);
    // console.log(
    //   "[ViewDocument] Content-Type:",
    //   response?.headers?.["content-type"],
    // );

    if (response?.status === 200 && response.data) {
      const contentType =
        response.headers?.["content-type"] || "application/octet-stream";

      // If the server returned JSON (e.g. error body) instead of a blob, it means
      // the file was not found or access was denied — don't try to open it
      if (contentType.includes("application/json")) {
        console.warn(
          "[ViewDocument] Server returned JSON instead of file — possible auth or path issue",
        );
        return { success: false, error: "Document not accessible" };
      }

      const blob = new Blob([response.data], { type: contentType });
      const url = URL.createObjectURL(blob);
      return { success: true, url, contentType };
    }

    console.warn("[ViewDocument] Unexpected response:", response?.status);
    return { success: false, error: "Failed to load document" };
  } catch (error) {
    // Log the full error details for debugging
    console.error("[ViewDocument] Error for filePath:", filePath);
    console.error("[ViewDocument] Error message:", error.message);
    console.error("[ViewDocument] Error status:", error?.response?.status);
    console.error("[ViewDocument] Error data:", error?.response?.data);

    // If this is a 401, the apiClient already redirected — but log it clearly
    if (error.message?.includes("Session expired")) {
      console.error(
        "[ViewDocument] ⚠️ 401 Unauthorized — token may be expired or filePath is invalid:",
        filePath,
      );
    }

    return { success: false, error: error.message };
  }
};
